// Helpers de roteamento do wizard de criação.
//
// O /criar (sem ID) existia como ponto de entrada que gerava/reusava o
// draftId e redirecionava pra /criar/<id>. Isso causava uma URL/tela
// intermediária visível ("tela de rascunho") entre o clique do usuário
// (ex.: card de plano) e o destino real do wizard. Usando este helper no
// onClick, o link já navega direto pra /criar/<id>, sem etapa visível.

import { useWizardStore } from "@/store";

function generateDraftId(): string {
  const alphabet = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
  let id = "";
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    const buf = new Uint32Array(10);
    window.crypto.getRandomValues(buf);
    for (let i = 0; i < 10; i++) id += alphabet[buf[i] % alphabet.length];
  } else {
    for (let i = 0; i < 10; i++) {
      id += alphabet[Math.floor(Math.random() * alphabet.length)];
    }
  }
  return `lp_${id}`;
}

/**
 * Resolve a URL definitiva do wizard (`/criar/<id>`) na hora do clique.
 *
 * - Reusa o `draftId` persistido no store quando o usuário ainda tem um
 *   rascunho em andamento (e o gift ainda não virou pagamento).
 * - Gera um novo `lp_XXXX` caso contrário, já gravando no store antes do
 *   push, pra que `/criar/<id>` encontre o ID hidratado.
 *
 * @param query string opcional já formatada (sem `?`). Ex.: `plan=PREMIUM`.
 */
export function resolveCriarHref(query?: string): string {
  const { draftId, giftId, setDraftId } = useWizardStore.getState();
  const reuseExisting = Boolean(draftId && !giftId);
  const id = reuseExisting ? draftId! : generateDraftId();
  if (!reuseExisting) setDraftId(id);
  return `/criar/${id}${query ? `?${query}` : ""}`;
}
